import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D9C230F8-C44C-4CE7-8DEF-891A531A1619
 * name chevron-right-box
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-right-box.svg
 * tags
 * - Arrow 
 */
export const ChevronRightBoxIcon = createSvgIcon(<><path d="M19,3H5A2,2 0 0,0 3,5V19C3,20.11 3.9,21 5,21H19C20.11,21 21,20.11 21,19V5A2,2 0 0,0 19,3M9.71,18L8.29,16.59L12.88,12L8.29,7.41L9.71,6L15.71,12L9.71,18Z" /></>, 'ChevronRightBoxIcon');
export default ChevronRightBoxIcon